export class ClusterGroupsSettings {
  constructor() {
    this.clusterGroupsDictionary = {};
  }

  add(featureGroupKey, clusterOptions) {
    if (clusterOptions != null) {
      this.clusterGroupsDictionary[featureGroupKey] = clusterOptions;
    } else {
      console.error('ClusterGroupsSettings.add(): The clusterOptions object must not be null.');
    }
  }

  get(featureGroupKey) {
    return this.clusterGroupsDictionary[featureGroupKey];
  }

  remove(featureGroupKey) {
    delete this.clusterGroupsDictionary[featureGroupKey];
  }

  logAll() {
    for (const featureGroupKey in this.clusterGroupsDictionary) {
      console.log(
        `featureGroupKey: ${featureGroupKey}, clusterOptions: ${this.clusterGroupsDictionary[featureGroupKey]}`
      );
    }
  }
}
